module.exports = __webpack_public_path__ + "img/mobile-26.7922a4f9.png";